import React from "react";

const UnAuthorized = () => {
  return <h1>403 - You are not authorized to view this page.</h1>;
};

export default UnAuthorized;
